import Card from 'components/Badge';
import { CloseButton, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { Text } from 'v3/components';
import theme from 'v3/theme';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const MapsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 10px;
  padding-top: 1rem;
  flex: 1;
  min-height: 100%;

  .leaflet-top,
  .leaflet-bottom,
  .leaflet-control {
    z-index: 500;
  }
`;

export const StyledClusterMarker = styled.div`
  color: #fff;
  background: #1978c8;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardStyled = styled(Card)`
  && {
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1) !important;
    background: white;
    opacity: 91%;
    z-index: 700;
    border-radius: 10px !important;
    width: auto;
    max-height: 150px;
    padding-right: 2.5rem;
    overflow: scroll;
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      width: 0.5rem;
      height: 0.5rem;
    }
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.light_gray};
      opacity: 0.5;
    }
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.gray};
      border-radius: 10px;
    }
    @media (max-width: 425px) {
      font-size: 1px !important;
      margin-top: 2% !important;
    }

    @media (max-width: 1440px) {
      font-size: 1px;
    }
  }
`;

export const TextView = styled(Text)`
  padding-left: 2%;
  cursor: pointer;
  color: ${theme.colors.light_blue};
`;

export const OpenInNewIconStyled = styled(OpenInNewIcon)`
  width: 15px !important;
`;

export const CloseButtonStyled = styled(CloseButton)`
  && {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 1;
  }
`;

export const MapButtonsCol = styled(Col)`
  display: flex;
  gap: 0.5rem;
`;

export const FullscreenButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
  width: 36px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  color: #5f6368;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover,
  &:focus {
    background: #f8f9fa;
    outline: none;
  }
`;
